import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { updateMenu } from "Redux/Actions/menuActions";
import "./MecenatGroupeAccueil.scss";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const MecenatGroupeAccueil = (props) => {
    const { t } = useTranslation("common");

    return (
        <div className="MecenatGroupeAccueil_container">
            <div className="MecenatGroupeAccueil_container__boxes responsive">
                <div className="MecenatGroupeAccueil_container__boxes__box">
                    <div className="MecenatGroupeAccueil_container__boxes__box__first">
                        <div className="MecenatGroupeAccueil_container__boxes__box__first__title">
                            <h2 className="MecenatGroupeAccueil_container__boxes__box__first__title__h2">
                                <p>Devenez<br /><span className='nowrap'>mécène&nbsp;!</span></p>
                            </h2>
                        </div>
                        <div className="MecenatGroupeAccueil_container__boxes__box__first__button">
                            {/* Ce texte remplace le bouton au début, style du bouton déja fait juste besoin de décommenter le moment venu */}
                            <div className="mecenatProvisoire">
                                {t("dons.description")}
                            </div>
                            {/* Bouton à décommenter le moment venu */}
                        </div>
                    </div>
                </div>
                <div className="MecenatGroupeAccueil_container__boxes__box">
                    <div className="MecenatGroupeAccueil_container__boxes__box__second"></div>
                </div>
                <div className="MecenatGroupeAccueil_container__boxes__box">
                    <div className="MecenatGroupeAccueil_container__boxes__box__third">
                        <div className="MecenatGroupeAccueil_container__boxes__box__third__title">
                            <h2 className="MecenatGroupeAccueil_container__boxes__box__third__title__h2">
                                {t("reseauDynamique.title_groupe")}
                            </h2>
                        </div>
                        <div className="MecenatGroupeAccueil_container__boxes__box__third__button">
                            <Link to="/groupes">
                                <button
                                    className="btn-bleu"
                                    onClick={() =>
                                        props.handleMenu({
                                            activeItemGroupes: props.items.itemsGroupes.findIndex(
                                                (v) => v.label == "Mes groupes d'échanges"
                                            ),
                                        })
                                    }
                                >
                                    {t("reseauDynamique.button_connected")}
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="MecenatGroupeAccueil_container__boxes__box">
                    <div className="MecenatGroupeAccueil_container__boxes__box__fourth"></div>
                </div>
            </div>
            <div className="MecenatGroupeAccueil_container__boxesResponsive">
                <div className="MecenatGroupeAccueil_container__boxesResponsive__firstBox">
                    <div className="MecenatGroupeAccueil_container__boxesResponsive__firstBox__title">
                        <h2 className="MecenatGroupeAccueil_container__boxesResponsive__firstBox__title__h2">
                            {" "}
                            Devenez mécène{" "}
                        </h2>
                    </div>
                    <div className="MecenatGroupeAccueil_container__boxesResponsive__firstBox__button">
                        {/* Ce texte remplace le bouton au début, style du bouton déja fait juste besoin de décommenter le moment venu */}
                        <div className="mecenatProvisoire">
                            Contribuez au rayonnement de la plus prestigieuse université de
                            France en sciences humaines et sociales.
                            Ensemble, faisons vivre les valeurs de transmission et d’excellence
                            qui font la fierté des Alumni de l&apos;Université USPN.
                        </div>
                        {/* Bouton à décommenter le moment venu */}
                        {/* <button className="btn-fondBlanc"> Découvrir le mécènat</button> */}
                    </div>
                    <div className="MecenatGroupeAccueil_container__boxes__box__first__button">
                        <button className="btn-fondBlanc" onClick={() => window.open('https://don-fondation.pantheonsorbonne.fr/donner/?mtm_campaign=dpeip_alumni_2025&mtm_kwd=dpeip', '_blank')}> FAIRE UN DON</button>
                    </div>
                </div>
                <div className="MecenatGroupeAccueil_container__boxesResponsive__secondBox">
                    <div className="MecenatGroupeAccueil_container__boxesResponsive__secondBox__title">
                        <h2 className="MecenatGroupeAccueil_container__boxesResponsive__secondBox__title__h2">
                            {" "}
                            Rejoignez un groupe{" "}
                        </h2>
                    </div>
                    <div className="MecenatGroupeAccueil_container__boxesResponsive__secondBox__button">
                        <Link to="/groupes">
                            <button
                                className="btn-bleu"
                                onClick={() =>
                                    props.handleMenu({
                                        activeItemGroupes: props.items.itemsGroupes.findIndex(
                                            (v) => v.label == "Mes groupes d'échanges"
                                        ),
                                    })
                                }
                            >
                                Accéder aux groupes
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

MecenatGroupeAccueil.propTypes = {
    handleMenu: PropTypes.func,
    items: PropTypes.object,
};

const mapStateToProps = (state) => ({
    items: state.items,
});

const mapDispatchToProps = (dispatch) => ({
    handleMenu: (value) => {
        dispatch(updateMenu(value));
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MecenatGroupeAccueil);
